var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "card", attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("select-source-title")))]),
      _vm.sourcesLoaded
        ? _c(
            "w-scroll-view",
            { staticClass: "list", attrs: { tag: "w-list" } },
            _vm._l(_vm.sources, function (item) {
              return _c(
                "w-list-item",
                {
                  key: item.value,
                  on: {
                    click: function ($event) {
                      return _vm.selectSource(item.value)
                    },
                  },
                },
                [_c("w-list-item-text", [_vm._v(_vm._s(item.text))])],
                1
              )
            }),
            1
          )
        : _c(
            "w-row",
            { attrs: { grow: "", center: "" } },
            [
              _c(
                "w-col",
                { attrs: { center: "", grow: "" } },
                [
                  _c(
                    "w-row",
                    { attrs: { center: "" } },
                    [_c("w-progress-circular")],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }